function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "none",
  opacity: 0,
  strokeWidth: 0
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m14.061,4.491c-.611-1.058-1.49-1.936-2.547-2.547-1.069-.615-2.28-.939-3.514-.939s-2.445.324-3.514.939c-1.058.611-1.937,1.489-2.548,2.547-.615,1.069-.939,2.28-.939,3.514s.324,2.445.939,3.514c.611,1.058,1.49,1.936,2.548,2.547,1.069.615,2.28.939,3.514.939s2.445-.324,3.514-.939c1.058-.611,1.936-1.49,2.547-2.547.615-1.069.939-2.28.939-3.514s-.324-2.445-.939-3.514Zm-1.978,4.097c-.002.154-.064.301-.173.41-.109.109-.256.171-.41.173h-2.333v2.333c-.002.154-.064.301-.173.41-.109.109-.256.171-.41.173h-1.167c-.154-.002-.301-.064-.41-.173-.109-.109-.171-.256-.173-.41v-2.333h-2.333c-.154-.002-.301-.064-.41-.173-.109-.109-.171-.256-.173-.41v-1.167c.002-.154.064-.301.173-.41.109-.109.256-.171.41-.173h2.333v-2.333c.002-.154.064-.301.173-.41.109-.109.256-.171.41-.173h1.167c.154.002.301.064.41.173s.171.256.173.41v2.333h2.333c.154.002.301.064.41.173s.171.256.173.41v1.167Z",
  fill: "#118af9",
  strokeWidth: 0
});

var SvgAddRangePlus = function SvgAddRangePlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-8cc8bc09-7f32-46db-8be2-d5076ab54525",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddRangePlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-range-plus.7f41acde.svg";
export { ForwardRef as ReactComponent };